module.exports = __webpack_public_path__ + "img/2.08cfb72c.png";